// extracted by mini-css-extract-plugin
module.exports = {"dropdownMenuContainer":"dropdownMenu_dropdownMenuContainer__83Xdz","dropdownMenuContainerBorder":"dropdownMenu_dropdownMenuContainerBorder__lgkMK"};